import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Spacer from "./spacer"

export default function Footer({ dark, light, brown }) {
    const { footer } = useStaticQuery(graphql`
        query SiteTitleQuery {
            footer: datoCmsFooter {
                instagramLink
                privacyPolicy {
                    url
                }
                disclaimer
                contactInfo {
                    id
                    title
                    text
                }
            }
        }
    `)

    return (
        <section className={`p40 pos-rel m-p20 pb20 ${dark ? "text-dark bg-brown-100" : ""} ${light ? "text-black bg-light" : ""} ${brown ? "text-white bg-brown" : ""}`}>
           
            <footer className={"pos-rel footer-grid align-bottom "}>
                <div className='fade--in m-hide' data-sal>
                    <a className='sm-copy ul-link' target='_blank' rel='noreferrer' href={footer.privacyPolicy.url}>
                        Privacy Policy
                    </a>
                </div>
                <div className='text-center small balance'>
                    <p className='max-600 ma'>{footer.disclaimer}</p>
                </div>
                <div className='text-right fade--in m-hide' data-sal>
                    <a className='sm-copy ul-link' target='_blank' rel='noreferrer' href={"https://www.instagram.com/" + footer.instagramLink}>
                        @{footer.instagramLink}
                    </a>
                </div>
                <div className='m-show m-mt40'>
                    <div className='flex'>
                        <a className='sm-copy ul-link' target='_blank' rel='noreferrer' href={footer.privacyPolicy.url}>
                            Privacy Policy
                        </a>
                        <a className='sm-copy ul-link mla' target='_blank' rel='noreferrer' href={"https://www.instagram.com/" + footer.instagramLink}>
                            @{footer.instagramLink}
                        </a>
                    </div>
                </div>
            </footer>
        </section>
    )
}
